import { merge } from 'lodash';

export type LabelValueObject = {
  label: string;
  value: number;
};
export enum PollResultKeys {
  buyside = 'Buyside',
  retail = 'Independent'
}
export type CombinedMonthlyResults = {
  name: string;
  [PollResultKeys.buyside]?: string;
  [PollResultKeys.retail]?: string;
};
export type CombinedMonthlyResultsContainer = { [key: string]: CombinedMonthlyResults };

export const combineAndFormatPollResults = (
  buysideData: LabelValueObject[],
  retailData: LabelValueObject[]
): CombinedMonthlyResultsContainer => {
  const buyside: CombinedMonthlyResultsContainer = buysideData.reduce(
    (acc: CombinedMonthlyResultsContainer, obj): CombinedMonthlyResultsContainer => {
      acc[obj.label] = {
        name: obj.label,
        [PollResultKeys.buyside]: obj.value.toFixed(1)
      };
      return acc;
    },
    {}
  );

  const retail: CombinedMonthlyResultsContainer = retailData.reduce(
    (acc: CombinedMonthlyResultsContainer, obj): CombinedMonthlyResultsContainer => {
      if (!acc[obj.label]) acc[obj.label] = { name: obj.label };
      acc[obj.label][PollResultKeys.retail] = obj.value.toFixed(1);
      return acc;
    },
    {}
  );

  return merge(buyside, retail);
};
